/**
 * useTranslation hook - wrapper for react-i18next
 *
 * Provides:
 * - t() function for translations
 * - language - current language code
 * - setLanguage - function to change language
 * - isEnglish/isItalian - quick language checks
 */

import { useTranslation as useI18nTranslation } from 'react-i18next';
import { useCallback } from 'react';

export type SupportedLanguage = 'en' | 'it';

export function useTranslation() {
  const { t, i18n } = useI18nTranslation();

  const language = i18n.language as SupportedLanguage;
  const isEnglish = language === 'en' || language?.startsWith('en');
  const isItalian = language === 'it' || language?.startsWith('it');

  const setLanguage = useCallback(
    (lang: SupportedLanguage) => {
      i18n.changeLanguage(lang);
    },
    [i18n]
  );

  return {
    t,
    language,
    setLanguage,
    isEnglish,
    isItalian,
    i18n,
  };
}

export default useTranslation;
